import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';

import { countryOptions } from '../../../tester/pages/sign-up-survey/options';
import { platformType } from '../../utils/platform-type';

import {
  Column,
  ColumnName,
  ColumnValue,
  Container,
  Divider,
  Grid,
  Row,
  Title,
  ShowProfileLink,
  Icon,
  Image,
  UserInterviewsMessage,
} from './styles';

const mapCountry = (flag) => {
  const country = countryOptions.find((c) => c.key === flag);
  return country && country.text;
};

const formatLocation = (country, state) => {
  const countryText = mapCountry(country);
  if (state && countryText) {
    return `${state}, ${countryText}`;
  }
  return countryText || null;
};

const calculateAge = (birthdate) => (`${moment().diff(birthdate, 'years')} years`);

const Demographics = (props) => {
  const {
    profile,
    showTitle,
    showLinkFullProfile,
    showEmail,
    onViewFullProfileClicked,
    link,
    compact,
    showUserInterviewsRecruited,
  } = props;

  const firstWidthColumn = showTitle ? 3 : 5;
  const secondWidthColumn = showTitle ? 10 : 8;

  const filteredProfile = {
    Gender: profile?.gender || null,
    Age: calculateAge(profile?.birthdate) || null,
    Location: formatLocation(profile?.country, profile?.state) || null,
    Ethnicity: profile?.raceEthnicHeritage || null,
    'Household Income': profile?.annualHouseholdIncome || null,
    Education: profile?.linkedinFields?.educationLevel || null,
    Email: (showEmail && platformType === 'company' && profile?.email) || null,
    'Contact Email': (showEmail && platformType !== 'company' && profile?.email) || null,
  };

  return (
    <Container compact={compact}>
      {showTitle && (
        <>
          <Title>
            Summary
            <Link to={link}><Icon name="pencil" /></Link>
          </Title>
          <Divider />
        </>
      )}
      <Grid columns={2}>
        {/* profile data */}
        {Object.keys(filteredProfile).map((key) => {
          if (filteredProfile[key] !== null) {
            return (
              <Row key={key}>
                <Column weight="500" width={firstWidthColumn}>
                  <ColumnName>
                    {key}
                  </ColumnName>
                </Column>
                <Column width={secondWidthColumn}>
                  <ColumnValue>
                    {filteredProfile[key]}
                  </ColumnValue>
                </Column>
              </Row>
            );
          }
          return null;
        })}
        {platformType === 'admin' && (
          <Row>
            <Column weight="500" width={3}>
              <ColumnName>
                Recruiting program
              </ColumnName>
            </Column>
            <Column width={10}>
              <ColumnValue>
                {profile.recruitingProgram ? 'Yes' : 'No'}
              </ColumnValue>
            </Column>
          </Row>
        )}
        {showLinkFullProfile && (
          <Row>
            <Column width={firstWidthColumn}>
              <ShowProfileLink onClick={onViewFullProfileClicked} href="#profile">View Full Profile</ShowProfileLink>
            </Column>
            <Column />
          </Row>
        )}
      </Grid>
      {platformType === 'company' && showUserInterviewsRecruited && (
        <UserInterviewsMessage>
          Participant recruited by
          <Image src="/images/user-interviews-logo.svg" alt="User Interviews" />
        </UserInterviewsMessage>
      )}
    </Container>
  );
};

Demographics.propTypes = {
  profile: PropTypes.shape({
    gender: PropTypes.string,
    birthdate: PropTypes.string,
    country: PropTypes.string,
    state: PropTypes.string,
    raceEthnicHeritage: PropTypes.string,
    annualHouseholdIncome: PropTypes.string,
    linkedinFields: PropTypes.shape({
      educationLevel: PropTypes.string,
    }),
    email: PropTypes.string,
    recruitingProgram: PropTypes.string,
  }).isRequired,
  showTitle: PropTypes.bool,
  showLinkFullProfile: PropTypes.bool,
  showEmail: PropTypes.bool,
  onViewFullProfileClicked: PropTypes.func,
  link: PropTypes.string,
  compact: PropTypes.bool,
  showUserInterviewsRecruited: PropTypes.bool,
};

Demographics.defaultProps = {
  showTitle: true,
  showLinkFullProfile: false,
  showEmail: true,
  onViewFullProfileClicked: undefined,
  compact: false,
  link: '',
  showUserInterviewsRecruited: false,
};

export default Demographics;
